import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import Helmet from '../../../components/Helmet';
import '../../../components/AIP/aip-banner-wrap.scss';
import { AIP_PRODUCT_SEO_TDK, type AipProductSeoKey } from '../seo-tdk';
import Finance from './details/Finance';
import Manufacture from './details/Manufacture';
import Planning from './details/Planning';
import Retail from './details/Retail';
import Project from './details/Project';
import Supplychain from './details/Supplychain';
import Supplierrelationships from './details/Supplierrelationships';
import Customerrelations from './details/Customerrelations';
import Onlinemall from './details/Onlinemall';
import HR from './details/HR';

type ProductName =
  | 'finance'
  | 'manufacturing'
  | 'production-planning'
  | 'retail'
  | 'project-management'
  | 'supply-chain'
  | 'srm'
  | 'crm'
  | 'ecommerce'
  | 'hcm';

const PRODUCT_COMPONENTS: Record<ProductName, React.ComponentType<any>> = {
  finance: Finance,
  manufacturing: Manufacture,
  'production-planning': Planning,
  retail: Retail,
  'project-management': Project,
  'supply-chain': Supplychain,
  srm: Supplierrelationships,
  crm: Customerrelations,
  ecommerce: Onlinemall,
  hcm: HR
};

export default function AipProductEntry(props: any) {
  const { productName } = useParams<{ productName?: string }>();

  if (!productName) return <Redirect to="/product" />;

  const Component = (PRODUCT_COMPONENTS as Record<string, React.ComponentType<any>>)[productName];
  if (!Component) return <Redirect to="/product" />;

  const seo =
    productName && productName in AIP_PRODUCT_SEO_TDK
      ? AIP_PRODUCT_SEO_TDK[productName as AipProductSeoKey]
      : undefined;

  return (
    <>
      {seo ? <Helmet title={seo.title} description={seo.description} keywords={seo.keywords} /> : null}
      <Component {...props} />
    </>
  );
}

